import { Box, Grid, Skeleton, Typography } from '@mui/material'

import useStyles from '../index.styles'

const OrderLoading = () => {
  const classes = useStyles

  return (
    <Grid sx={classes.orderDetailsContainer}>
      <Grid container={true} size={12} sx={classes.orderDetailsHeader}>
        <Grid container={true} sx={classes.orderDetailsHeaderColumn}>
          <Typography variant="caption" sx={classes.secondaryText}>
            <Skeleton />
          </Typography>
          <Typography variant="body1">
            <Skeleton />
          </Typography>
          <Typography variant="body2" sx={classes.secondaryText}>
            <Skeleton />
          </Typography>
        </Grid>
      </Grid>

      <Grid container={true} size={12} sx={classes.orderListContainer}>
        <Typography variant="subtitle1" sx={classes.orderListTitle}>
          <Skeleton />
        </Typography>

        <Box sx={classes.orderListGrid(3)}>
          <Typography variant="body2" sx={classes.orderListHeaderQuantity}>
            <Skeleton />
          </Typography>
          <Typography variant="body2" sx={classes.orderListHeaderItem}>
            <Skeleton />
          </Typography>
          <Typography variant="body2" sx={classes.orderListQuantityText}>
            <Skeleton width="76px" />
          </Typography>
          <Typography variant="body2" sx={classes.orderListItemText}>
            <Skeleton />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default OrderLoading
